export function getErrorText(errors: readonly unknown[]): string {
  const messages = errors.flatMap((error) => getErrorMessages(error));
  return Array.from(new Set(messages)).join('\n');
}

function getErrorMessages(error: unknown): string[] {
  if (!error) {
    return [];
  }

  if (Array.isArray(error)) {
    return error.flatMap((nestedError) => getErrorMessages(nestedError));
  }

  if (typeof error === 'string') {
    return [error];
  }

  if (error instanceof Error) {
    return [error.message];
  }

  if (typeof error === 'object' && 'message' in error) {
    const { message } = error;
    if (typeof message === 'string') {
      return [message];
    }
  }

  return [String(error)];
}
